import ApplicationController from './application_controller'
import { ClassToggler } from '../classes/classToggler'
import Trix from 'trix'

export default class extends ApplicationController {
  static get targets() {
    return ['input', 'characterCount', 'clearButton', 'liveRegion', 'submitButton']
  }

  doConnect() {
    Trix.config.textAttributes.underline = { tagName: 'u', inheritable: false }

    this.element.addEventListener('trix-file-accept', (event) => {
      event.preventDefault()
      console.log('File attachment not supported!')
    })

    this.element.addEventListener('trix-initialize', function(event) {
      const element = event.target
      const editor = element.editor
      const toolbarElement = element.toolbarElement
      const groupElement = toolbarElement.querySelector('.trix-button-group.trix-button-group--text-tools .trix-button.trix-button--icon.trix-button--icon-strike')
      groupElement.insertAdjacentHTML('afterend', '<button type="button" class="trix-button trix-button--icon trix-button--icon-underline" title="underline" data-trix-attribute="underline"><sub>Underline</sub></button>')

      let selectedAttributes = new Set()

      function updateSelectedAttributes() {
        selectedAttributes = new Set()

        const selectedRange = editor.getSelectedRange()
        if (selectedRange[0] === selectedRange[1]) { selectedRange[1]++ }

        const selectedPieces = editor.getDocument().getDocumentAtRange(selectedRange).getPieces()
        selectedPieces.forEach(function(piece) {
          Object.keys(piece.getAttributes()).forEach(function(attribute) {
            selectedAttributes.add(attribute)
          })
        })
      }

      updateSelectedAttributes()
      element.addEventListener('trix-selection-change', updateSelectedAttributes)

      if (element.dataset.content) {
        editor.insertHTML(element.dataset.content)
      }

      const elementButtons = event.target.toolbarElement.querySelectorAll('button')

      for (let i = 0; i < elementButtons.length; i++) {
        elementButtons[i].removeAttribute('tabIndex')
        elementButtons[i].setAttribute('aria-label', elementButtons[i].title)
        elementButtons[i].onmousedown = null
        elementButtons[i].addEventListener('keypress', event => {
          if (event.key === 'Enter') {
            const mouseEvent = new MouseEvent('mousedown', {
              bubbles: true,
              cancelable: true,
              view: window
            })
            event.target.dispatchEvent(mouseEvent)
          }
        })
      }
    })

    this.element.addEventListener('trix-change', event => {
      const { editor } = event.target
      const string = editor.getDocument().toString()
      const characterCount = string.length - 1
      const valueMaximum = this.getParam(this.inputTarget, 'character-limit')
      const errorMessage = this.getParam(this.inputTarget, 'error-message')
      const charactersRemaining = valueMaximum - characterCount
      this.setParam(this.inputTarget, 'characters-remaining', charactersRemaining)

      if (this.hasCharacterCountTarget) {
        if (valueMaximum <= 0) {
          this.characterCountTarget.textContent = errorMessage
        } else {
          this.characterCountTarget.textContent = charactersRemaining + ' characters remaining.'
        }
        this.validate()
      }
    })
  }

  validate() {
    if (this.getParam(this.inputTarget, 'characters-remaining') < 0) {
      document.getElementById('submit-button').setAttribute('disabled', true)
      this.itemClassToggler(this.characterCountTarget).addAllClasses()
      this.itemClassToggler(this.inputTarget).addAllClasses()
    } else {
      document.getElementById('submit-button').removeAttribute('disabled')
      this.itemClassToggler(this.characterCountTarget).removeAllClasses()
      this.itemClassToggler(this.inputTarget).removeAllClasses()
    }
  }

  itemClassToggler(item) {
    return new ClassToggler(item, 'c-trix__invalid-elem')
  }
}
